import Box from '@mui/material/Box'
import type { FormNode } from '../../../../types/form.types'
import { resolveMuiIcon } from './muiIconMap'

export type ButtonContentMode = 'text' | 'icon' | 'both'

export function effectiveButtonContentMode(node: FormNode): ButtonContentMode {
  if (node.buttonContentMode) return node.buttonContentMode
  const hasGraphic = !!(node.buttonImageUrl || node.buttonIcon)
  const hasText = !!(node.title?.trim() || node.name?.trim())
  if (hasGraphic && hasText) return 'both'
  if (hasGraphic) return 'icon'
  return 'text'
}

export function buttonShowsText(node: FormNode): boolean {
  const mode = effectiveButtonContentMode(node)
  return mode === 'text' || mode === 'both'
}

function buttonGraphicSource(node: FormNode): 'mui' | 'image' {
  return node.buttonIconSource ?? (node.buttonImageUrl ? 'image' : 'mui')
}

export function buttonHasGraphic(node: FormNode): boolean {
  const source = buttonGraphicSource(node)
  return source === 'image' ? !!node.buttonImageUrl : !!node.buttonIcon
}

export function buttonShowsGraphic(node: FormNode): boolean {
  const mode = effectiveButtonContentMode(node)
  if (mode === 'text') return false
  return buttonHasGraphic(node)
}

export function buttonLabel(node: FormNode): string {
  return node.title?.trim() || node.name || ''
}

export function ButtonGraphic({ node, size = 18 }: { node: FormNode; size?: number }) {
  const source = buttonGraphicSource(node)
  if (source === 'image' && node.buttonImageUrl) {
    return (
      <Box
        component="img"
        src={node.buttonImageUrl}
        alt=""
        sx={{ width: size, height: size, objectFit: 'contain', display: 'block' }}
      />
    )
  }
  const Icon = resolveMuiIcon(node.buttonIcon)
  if (Icon) return <Icon sx={{ fontSize: size }} />
  return null
}
